import React, { useState, useEffect, Fragment } from 'react';
// import { Deck, Slide } from 'spectacle';
import styled, { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import theme from './theme';
import { mergeTheme, oneTheme } from './deckTheme';

import VocationOneLogoWhite from './imgs/vocation_one_logo_white2x.png';
import EdumetricsLogo from './imgs/edumetrics_logo.png';
import MapaOrientacion from './imgs/mapa-orientacion-carreras_updated.png';
import EstiloDecisionModel from './imgs/estilo_decision_model.png';
import DifInformacionModel from './imgs/diff_informacion_model.png';
import Icon02 from './imgs/icons/edu_iconos_6.svg';
import Icon03 from './imgs/icons/edu_iconos_3.svg';
import Icon05 from './imgs/icons/edu_iconos_5.svg';
import Icon07 from './imgs/icons/edu_iconos_7.svg';

import { ResetCSS, GlobalStyle, PageWrapper, PageNumber } from './styles';

// pages
import GradeDistributionChart from './GradeDistributionChart';
import AreasStackedChart from './AreasStackedChart';
import KnowledgeAreasStackedChart from './KnowledgeAreasStackedChart';
import HorizontalRangeScale from './HorizontalRangeScale';

const Deck = props => {
  const style = {
    position: 'relative',
    height: `${props.theme.size.height}px`,
    width: `${props.theme.size.width}px`,
    backgroundColor: props.backgroundColor || '#FFFFFF',
    page: 'report' // css page definition
  };
  return <div style={style}>{props.children}</div>;
};

const Slide = props => {
  const style = {
    position: 'relative',
    height: `100%`,
    width: `100%`,
    backgroundColor: props.backgroundColor || 'transparent'
  };
  return (
    <div className='page' id='report' style={style}>
      {props.children}
    </div>
  );
};

export const ChartWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: ${({ height }) => (height ? height : 400)}px;
  width: 100%;
`;

// Slider Deck theme
const deckTheme = mergeTheme(oneTheme);
console.log({ deckTheme });

export const SlidePage = ({
  number,
  children,
  background,
  isFullCover,
  ...rest
}) => {
  // const isEven = number % 2 === 0;
  // console.log({ number, isEven });
  return (
    <PageWrapper {...rest} backgroundImage={background}>
      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 45,
          left: 25
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon02}
          alt='edumetrics vocation start logo'
          style={{
            width: 200,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 200,
          // top: 285,
          left: isFullCover ? 150 : 400
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon07}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 250 : 185,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: isFullCover ? 100 : 250,
          right: isFullCover ? 100 : 460
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon03}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 300 : 225,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: isFullCover ? 0 : -50,
          // top: 225,
          right: isFullCover ? 150 : 250
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon05}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 275 : 225,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      {children}
      {number && <PageNumber>{number}</PageNumber>}
    </PageWrapper>
  );
};
// caso real
// /c/4e11a22e-fc10-486f-b2ba-b33c079e1af2/k4l_cGUhF8LbRe0vn2_aE?exportMode=true

const SlideHeader = ({ campaign }) => {
  const campaignLogo = campaign?.metadata?.logo ? campaign.metadata.logo : null;
  return (
    <div className='slide-header'>
      {campaignLogo && (
        <div className='logo'>
          <img
            src={campaignLogo}
            alt={`${campaign.organization || 'campaign'} logo`}
          />
        </div>
      )}
      <div className='logo'>
        <img src={EdumetricsLogo} alt='edumetrics logo' />
      </div>
      {/* <div className='logo'>
      <img src={ABLogo} alt='Albert Bridge logo' />
    </div> */}
    </div>
  );
};

const PlainHeader = () => (
  <div className='plain-header right'>
    <div className='logo-big'>
      <img src={VocationOneLogoWhite} alt='vocation-one logo' />
    </div>
  </div>
);

const getSumFomValues = (values = []) => {
  const sum = values
    .filter(Boolean)
    .reduce((acc, curr) => acc + parseFloat(curr), 0);
  return sum;
};

const getMeanFromValues = (values = []) => {
  const sum = getSumFomValues(values);
  const mean = sum / values.length;
  return mean;
};

const VocationOneCollege = ({ campaign, responses: dataResponses }) => {
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(false);
  // const [user, setUser] = useState(null);
  const [campaignData, setCampaignData] = useState({});
  const [responses, setResponses] = useState([]);
  // console.log({ props });

  useEffect(() => {
    // console.log({ params });
    const parseInitialData = async () => {
      const parseUser = response => {
        const userData = response.data;
        // console.log({ userData });
        const fields = Object.keys(userData);
        const FIRST_AREA_ITEMS = fields.filter(
          field => field.includes('_FIRST_SUM') && !field.includes('perc_')
        );
        const SECOND_AREA_ITEMS = fields.filter(
          field => field.includes('_SECOND_SUM') && !field.includes('perc_')
        );
        const THIRD_AREA_ITEMS = fields.filter(
          field => field.includes('_THIRD_SUM') && !field.includes('perc_')
        );
        const FOURTH_AREA_ITEMS = fields.filter(
          field => field.includes('_FOURTH_SUM') && !field.includes('perc_')
        );
        const sortedFirstAreaSums = FIRST_AREA_ITEMS.map(fieldKey => ({
          area: fieldKey.replace('_FIRST_SUM', ''),
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        })).sort((a, b) => b.value - a.value);
        const sortedSecondAreaSums = SECOND_AREA_ITEMS.map(fieldKey => ({
          area: fieldKey.replace('_SECOND_SUM', ''),
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        })).sort((a, b) => b.value - a.value);
        const sortedThirdAreaSums = THIRD_AREA_ITEMS.map(fieldKey => ({
          area: fieldKey.replace('_THIRD_SUM', ''),
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        })).sort((a, b) => b.value - a.value);
        const sortedFourthAreaSums = FOURTH_AREA_ITEMS.map(fieldKey => ({
          area: fieldKey.replace('_FOURTH_SUM', ''),
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        })).sort((a, b) => b.value - a.value);
        const decisionFields = [
          'Afrontamiento Productivo',
          'Búsqueda de Apoyo',
          'Afrontamiento No-Producivo'
        ];
        const sortedDecisionStyle = decisionFields
          .map(fieldKey => ({
            field: fieldKey,
            value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
          }))
          .sort((a, b) => b.value - a.value);
        // console.log({ sortedFirstAreaSums, sortedSecondAreaSums });
        // console.log({ sortedDecisionStyle });
        const infoInconsistenteFallback =
          (getMeanFromValues([
            userData['DI_19'],
            userData['DI_20'],
            userData['DI_21']
          ]) /
            9) *
          100;
        const infoInconsistente = userData['Información inconsistente'];

        const extras = {
          'Información inconsistente': infoInconsistente
            ? parseFloat(infoInconsistente)
            : infoInconsistenteFallback
        };

        const parsedUser = {
          ...userData,
          ...extras,
          FIRST_AREA_ITEMS,
          SECOND_AREA_ITEMS,
          THIRD_AREA_ITEMS,
          FOURTH_AREA_ITEMS,
          TOP_FIRST_1: sortedFirstAreaSums[0]?.area,
          TOP_FIRST_2: sortedFirstAreaSums[1]?.area,
          TOP_SECOND_1: sortedSecondAreaSums[0]?.area,
          TOP_SECOND_2: sortedSecondAreaSums[1]?.area,
          TOP_THIRD_1: sortedThirdAreaSums[0]?.area,
          TOP_THIRD_2: sortedThirdAreaSums[1]?.area,
          TOP_FOURTH_1: sortedFourthAreaSums[0]?.area,
          TOP_FOURTH_2: sortedFourthAreaSums[1]?.area,
          TOP_DECISION_STYLE: sortedDecisionStyle[0]?.field,
          createdAt: response.createdAt,
          updatedAt: response.updatedAt
        };
        return { ...response, data: parsedUser };
      };
      const parseResponses = () => {
        return dataResponses.map(resp => parseUser(resp));
      };

      const parseCampaign = resps => {
        const male = resps.filter(resp => resp.data.SEX === 'Masculino');
        const female = resps.filter(resp => resp.data.SEX === 'Femenino');
        const grades = [...new Set(resps.map(resp => resp.data.grade))]
          .sort((a, b) => a.localeCompare(b))
          .filter(Boolean); // clean undefined and falsy grades (with no list)
        const gradeResponses = grades.map(grade => {
          return {
            grade,
            responses: resps.filter(resp => resp.data.grade === grade)
          };
        });
        console.log({ gradeResponses });
        const infoData = { grades, male, female, gradeResponses };
        return infoData;
      };
      const campaignResponses = parseResponses();
      const campaignInfoData = parseCampaign(campaignResponses);
      console.log({ campaignInfoData });
      console.log({ campaignResponses });

      await setCampaignData(campaignInfoData);
      await setResponses(campaignResponses);
      await setLoading(false);
    };
    parseInitialData();
  }, [campaign, dataResponses]);

  // console.log({ campaign, responses });

  // console.log({ user });
  if (loading) {
    return <div>loading...</div>;
  }
  if (!campaign || !responses) {
    return <div>loading...</div>;
  }
  if (!campaignData) {
    return <div>loading...</div>;
  }
  if (!campaignData.gradeResponses) {
    return <div>loading...</div>;
  }
  // console.log({ campaignData });

  const firstStep = 6;
  const gradesLength = campaignData.grades.length;
  // console.log({ gradesLength });
  const hasGrades = gradesLength > 1;
  const secondStep = hasGrades
    ? firstStep + gradesLength
    : firstStep - gradesLength;
  const thirdStep = hasGrades ? secondStep + gradesLength + 3 : secondStep + 3;
  const fourthStep = hasGrades ? thirdStep + gradesLength + 3 : thirdStep + 3;
  const fifthStep = hasGrades ? fourthStep + gradesLength + 1 : fourthStep + 1;
  const sixthStep = hasGrades ? fifthStep + gradesLength + 1 : fifthStep + 1;
  const seventhStep = hasGrades ? sixthStep + gradesLength + 3 : sixthStep + 3;

  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Helmet>
          <title>{`${(campaign.organization || campaign.title)
            .split(' ')
            .join('_')}_VocationOne_${campaign.id}`}</title>
        </Helmet>
        <ResetCSS />
        <GlobalStyle />
        <Deck theme={deckTheme} backgroundColor='#5a86e8'>
          <Slide backgroundColor='#5a86e8'>
            <SlidePage isFullCover>
              {campaign?.metadata?.logo && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={campaign.metadata.logo}
                    alt={`${campaign.organization || 'campaign'} logo`}
                    style={{
                      maxWidth: 250,
                      height: 100,
                      display: 'block',
                      objectFit: 'contain',
                      marginTop: 48
                    }}
                  />
                </div>
              )}
              <div className='title-page'>
                <div className='logo-big'>
                  <img src={VocationOneLogoWhite} alt='vocation-one logo' />
                </div>
              </div>
              <div
                className='top-body'
                style={{ paddingLeft: '5rem', paddingRight: '5rem' }}
              >
                <h1>Presentación de Resultados</h1>
                <h2>{campaign.organization || campaign.title}</h2>
              </div>
            </SlidePage>
          </Slide>

          {/** BLANK PAGE */}
          <Slide backgroundColor='#5a86e8'>
            <SlidePage isFullCover></SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={1}>
              <SlideHeader campaign={campaign} />
              <div className='half-left'>
                <div>
                  <h1>
                    <span>¿</span>Qué es{' '}
                    <span>
                      <img
                        src={VocationOneLogoWhite}
                        style={{ marginLeft: '1rem' }}
                        alt='vocation-one logo'
                      />
                    </span>
                    <span>?</span>
                  </h1>
                </div>
              </div>
              <div className='slide-body right'>
                <div className='slide-content'>
                  <div className='flex-center'>
                    <p>
                      <strong>Vocation One</strong> es un test de orientación
                      vocacional para estudiantes de enseñanza media, diseñado
                      por Edumetrics.
                      <br />
                      <br />
                      Basado en un modelo que incluye{' '}
                      <strong>8 orientaciones vocacionales</strong> y{' '}
                      <strong>10 áreas de conocimiento</strong>, donde se
                      encontrarían las carreras idóneas para el perfil del
                      estudiante. El objetivo de este test es poder visualizar y
                      aclarar aquellas áreas que al estudiante{' '}
                      <strong>le gustan o que prefiere</strong>.
                      <br />
                      <br />A diferencia de los test tradicionales basados en
                      preferencias, <strong>Vocation One</strong> está{' '}
                      <strong>orientado a la toma de decisiones</strong> lo que
                      implica priorizar y seleccionar cursos de acción.
                    </p>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={2}>
              <SlideHeader campaign={campaign} />
              <div className='half-left'>
                <div>
                  <h1>
                    <span>¿</span>Qué es{' '}
                    <span>
                      <img
                        src={VocationOneLogoWhite}
                        style={{ marginLeft: '1rem' }}
                        alt='vocation-one logo'
                      />
                    </span>
                    <span>?</span>
                  </h1>
                </div>
              </div>
              <div className='slide-body right'>
                <div className='slide-content'>
                  <h1>Objetivo</h1>
                  <div>
                    <ul>
                      <li>
                        Entregar información relevante a estudiantes para el
                        proceso de toma de decisiones de carrera,
                        específicamente en relación a preferencias vocacionales
                        y características personales sobre el proceso de toma de
                        decisión.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            <Slide backgroundColor='#5a86e8'>
              <SlidePage number={3}>
                <SlideHeader campaign={campaign} />
                <div className='third-left'>
                  <div>
                    <h1>Distribución de estudiantes participantes</h1>
                  </div>
                  <div className='footnote'>
                    <div>Número de participantes por curso</div>
                  </div>
                </div>
                <div className='slide-body big'>
                  <div className='slide-content'>
                    <h1>Distribución Detallada</h1>
                    <p style={{ fontSize: '1.5rem' }}>
                      <strong>Total</strong> = {responses.length} participantes.{' '}
                      {'('}
                      {campaignData?.gradeResponses.map((g, idx) => {
                        const isLast =
                          idx === campaignData.gradeResponses.length - 1;
                        return (
                          <Fragment key={`${g.grade}_${idx.toString()}_resp`}>
                            <strong>{g.grade}</strong>
                            {' = '}
                            <span>{g.responses.length}</span>
                            {isLast ? '' : '; '}
                          </Fragment>
                        );
                      })}
                      {')'}
                    </p>
                    <div>
                      <br />
                      <ChartWrapper height={600}>
                        <GradeDistributionChart
                          grades={campaignData.gradeResponses}
                        />
                      </ChartWrapper>
                    </div>
                  </div>
                </div>
              </SlidePage>
            </Slide>
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={hasGrades ? 4 : 3}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Orientación Vocacional</h1>
                <h2>Preferencias Principales</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={hasGrades ? 5 : 4}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Preferencias Principales</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <p>
                      El Test Vocation One identifica las preferencias de los
                      estudiantes en base a un modelo circular de 8 áreas
                      principales.
                    </p>
                  </div>
                  <div className='image-wrapper'>
                    <img
                      style={{ height: 800, marginTop: -25 }}
                      src={MapaOrientacion}
                      alt='modelo-vocacional'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={hasGrades ? 6 : 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Preferencias Principales</h1>
                  <h2>Distribución General</h2>
                  {!hasGrades && (
                    <p style={{ fontSize: '1.85rem', color: '#ffffff' }}>
                      <strong>Total</strong> = {responses.length} participantes.
                    </p>
                  )}
                </div>
                <div className='footnote'>
                  <div>
                    Número de estudiantes agrupados según su nivel de interés en
                    las distintas preferencias principales
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <AreasStackedChart responses={responses} />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData.gradeResponses.map((grade, index) => (
              <Slide backgroundColor='#5a86e8' key={`areas${grade.grade}`}>
                <SlidePage number={firstStep + index + 1}>
                  <SlideHeader campaign={campaign} />
                  <div className='third-left'>
                    <div>
                      <h1>Preferencias Principales</h1>
                      <h2>Distribución {grade.grade}</h2>
                    </div>
                    <div className='footnote'>
                      <div>
                        Número de estudiantes de curso {grade.grade} agrupados
                        según su nivel de interés en las distintas áreas
                        prioritarias
                      </div>
                    </div>
                  </div>
                  <div className='slide-body big'>
                    <div className='slide-content'>
                      <h1>Distribución {grade.grade}</h1>
                      <div>
                        <ChartWrapper height={700}>
                          <AreasStackedChart responses={grade.responses} />
                        </ChartWrapper>
                      </div>
                    </div>
                  </div>
                </SlidePage>
              </Slide>
            ))
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={secondStep + 1}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Orientación Vocacional</h1>
                <h2>Áreas De Conocimiento</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={secondStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Áreas De Conocimiento</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Número de estudiantes que seleccionan cada área de
                    conocimiento como primera prioridad
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General (1º Prioridad)</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <KnowledgeAreasStackedChart
                        order='FIRST'
                        responses={responses}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData.gradeResponses.map((grade, index) => (
              <Slide backgroundColor='#5a86e8' key={`disc${grade.grade}`}>
                <SlidePage number={secondStep + index + 3}>
                  <SlideHeader campaign={campaign} />
                  <div className='third-left'>
                    <div>
                      <h1>Disciplinas de Interés</h1>
                      <h2>Prioridades {grade.grade}</h2>
                    </div>
                    <div className='footnote'>
                      <div>
                        Número de estudiantes {grade.grade} que seleccionan cada
                        área de conocimiento como primera prioridad
                      </div>
                    </div>
                  </div>
                  <div className='slide-body big'>
                    <div className='slide-content'>
                      <h1>Distribución {grade.grade} (1º Prioridad)</h1>
                      <div>
                        <ChartWrapper height={700}>
                          <KnowledgeAreasStackedChart
                            order='FIRST'
                            responses={grade.responses}
                          />
                        </ChartWrapper>
                      </div>
                    </div>
                  </div>
                </SlidePage>
              </Slide>
            ))
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={thirdStep}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Orientación Vocacional</h1>
                <h2>Toma de Decisiones</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={thirdStep + 1}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Toma de decisión de carrera</h1>
                    <p>
                      Esta sección del test permite conocer algunas de las
                      características de cada estudiante frente al proceso de
                      tomar decisiones y algunas dificultades asociadas a este
                      proceso. Esta información puede ayudar a decidir qué
                      aspectos se deben revisar o qué estrategias se pueden
                      implementar para enfrentar de mejor manera este proceso y
                      sentirse más seguro/a con una decisión.
                    </p>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={thirdStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Motivación por el Proceso</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en ROJO sugieren un bajo nivel de motivación por
                    el proceso de toma de decisiones vocacional. Resultados en
                    VERDE sugieren un buen nivel de motivación por participar en
                    este proceso.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Motivación por el Proceso</h1>
                  <p>
                    Se refiere al impulso interno que nos lleva a participar
                    activamente en la exploración de alternativas y toma de
                    decisiones sobre el futuro profesional. Es un factor
                    fundamental para iniciar y mantenerse comprometido/a en este
                    proceso de elección.
                  </p>
                  <p>
                    Es importante recordar que la motivación puede
                    desarrollarse, para lo cual es clave reflexionar en torno a
                    los intereses y metas personales, para identificar aquellas
                    cosas que pueden resultar más atractivas dentro del proceso
                    de toma de decisiones de carrera, y que puedan servir para
                    involucrarse de forma más activa en este proceso.
                  </p>
                  <div className='scales-range' style={{ height: 300 }}>
                    <div className='range-single'>
                      <div className='label'>General</div>
                      <HorizontalRangeScale
                        scale='Motivación'
                        responses={responses}
                        inverted
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData.gradeResponses.map((grade, index) => {
              return (
                <Slide
                  backgroundColor='#5a86e8'
                  key={`mot_gral_${grade.grade}_${index}`}
                >
                  <SlidePage number={thirdStep + 3 + index}>
                    <SlideHeader campaign={campaign} />
                    <div className='third-left'>
                      <div>
                        <h1>Toma de Decisiones</h1>
                        <h2>Motivación por el Proceso {grade.grade}</h2>
                      </div>
                      <div className='footnote'>
                        <div>
                          Resultados en ROJO sugieren un bajo nivel de
                          motivación por el proceso de toma de decisiones
                          vocacional. Resultados en VERDE sugieren un buen nivel
                          de motivación por participar en este proceso.
                        </div>
                      </div>
                    </div>

                    <div className='slide-body big'>
                      <div className='slide-content'>
                        <div>
                          <h1>Motivación por el Proceso</h1>
                          <p>
                            Se refiere al impulso interno que nos lleva a
                            participar activamente en la exploración de
                            alternativas y toma de decisiones sobre el futuro
                            profesional. Es un factor fundamental para iniciar y
                            mantenerse comprometido/a en este proceso de
                            elección.
                          </p>
                          <p>
                            Es importante recordar que la motivación puede
                            desarrollarse, para lo cual es clave reflexionar en
                            torno a los intereses y metas personales, para
                            identificar aquellas cosas que pueden resultar más
                            atractivas dentro del proceso de toma de decisiones
                            de carrera, y que puedan servir para involucrarse de
                            forma más activa en este proceso.
                          </p>
                          <div className='scales-range' style={{ height: 300 }}>
                            <div className='range-single'>
                              <div className='label'>{grade.grade}</div>
                              <HorizontalRangeScale
                                scale='Motivación'
                                responses={grade.responses}
                                inverted
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SlidePage>
                </Slide>
              );
            })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={fourthStep}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Creencias Disfuncionales</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en ROJO sugieren la alta presencia de creencias
                    disfuncionales en estas áreas. Resultados en VERDE sugieren
                    la baja presencia o ausencia de creencias disfuncionales.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Creencias Disfuncionales</h1>
                  <p>
                    El tener ideas o creencias equivocadas sobre las
                    implicancias del proceso de elección de carrera es una de
                    las dificultades más importantes y más comunes que enfrentan
                    las personas al momento de tomar este tipo de decisiones.
                  </p>
                  <p>
                    Es importante identificar estas creencias erróneas y
                    cuestionarlas, ya que pueden estar obstaculizando el proceso
                    de toma de decisión.
                  </p>
                  <div className='scales-range' style={{ height: 450 }}>
                    <div className='range-row'>
                      <div className='label small'>
                        El rol de la casualidad y el destino
                      </div>
                      <HorizontalRangeScale
                        scale='Rol de la casualidad'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label small'>
                        Implicancias de la Decisión
                      </div>
                      <HorizontalRangeScale
                        scale='Implicancias de la Decisión'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label small'>
                        Creencias sobre el rol de otros en la decisión
                      </div>
                      <HorizontalRangeScale
                        scale='Rol de otros significativos'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label small'>
                        Rol de la ayuda profesional
                      </div>
                      <HorizontalRangeScale
                        scale='Rol de la ayuda profesional'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label small'>
                        Creencias en relación al género
                      </div>
                      <HorizontalRangeScale
                        scale='Género'
                        responses={responses}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData.gradeResponses.map((grade, index) => {
              return (
                <Slide
                  backgroundColor='#5a86e8'
                  key={`study__${grade.grade}_${index}`}
                >
                  <SlidePage number={fourthStep + 1 + index}>
                    <SlideHeader campaign={campaign} />
                    <div className='third-left'>
                      <div>
                        <h1>Toma de Decisiones</h1>
                        <h2>Creencias Disfuncionales {grade.grade}</h2>
                      </div>
                      <div className='footnote'>
                        <div>
                          Resultados en ROJO sugieren la alta presencia de
                          creencias disfuncionales en estas áreas. Resultados en
                          VERDE sugieren la baja presencia o ausencia de
                          creencias disfuncionales.
                        </div>
                      </div>
                    </div>
                    <div className='slide-body big'>
                      <div className='slide-content'>
                        <h1>Creencias Disfuncionales {grade.grade}</h1>
                        <div className='scales-range' style={{ height: 650 }}>
                          <div className='range-row'>
                            <div className='label'>
                              El rol de la casualidad y el destino
                            </div>
                            <HorizontalRangeScale
                              scale='Rol de la casualidad'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Implicancias de la Decisión
                            </div>
                            <HorizontalRangeScale
                              scale='Implicancias de la Decisión'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Creencias sobre el rol de otros en la decisión
                            </div>
                            <HorizontalRangeScale
                              scale='Rol de otros significativos'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Rol de la ayuda profesional
                            </div>
                            <HorizontalRangeScale
                              scale='Rol de la ayuda profesional'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Creencias en relación al género
                            </div>
                            <HorizontalRangeScale
                              scale='Género'
                              responses={grade.responses}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </SlidePage>
                </Slide>
              );
            })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={fifthStep}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Indecisión como rasgo personal</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en ROJO sugieren la alta presencia de creencias
                    disfuncionales en estas áreas. Resultados en VERDE sugieren
                    la baja presencia o ausencia de creencias disfuncionales.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Indecisión como rasgo personal</h1>
                    <p>
                      Es importante diferenciar si la indecisión en relación a
                      la elección de carrera es por este momento o situación en
                      específico, o si existe una tendencia a ser una persona
                      indecisa en general.
                    </p>
                    <p>
                      La toma de decisiones es una habilidad que puede se puede
                      aprender, practicar y mejorar con el tiempo, lo que puede
                      ayudar a disminuir rasgos de indecisión general.
                    </p>
                    <div className='scales-range' style={{ height: 300 }}>
                      <div className='range-single'>
                        <div className='label'>General</div>
                        <HorizontalRangeScale
                          scale='Indecisión General'
                          responses={responses}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData.gradeResponses.map((grade, index) => {
              return (
                <Slide
                  backgroundColor='#5a86e8'
                  key={`ind_gral_${grade.grade}_${index}`}
                >
                  <SlidePage number={fifthStep + 1 + index}>
                    <SlideHeader campaign={campaign} />
                    <div className='third-left'>
                      <div>
                        <h1>Toma de Decisiones</h1>
                        <h2>Indecisión como rasgo personal {grade.grade}</h2>
                      </div>
                      <div className='footnote'>
                        <div>
                          Resultados en ROJO sugieren la alta presencia de
                          creencias disfuncionales en estas áreas. Resultados en
                          VERDE sugieren la baja presencia o ausencia de
                          creencias disfuncionales.
                        </div>
                      </div>
                    </div>

                    <div className='slide-body big'>
                      <div className='slide-content'>
                        <div>
                          <h1>Indecisión como rasgo personal</h1>
                          <p>
                            Es importante diferenciar si la indecisión en
                            relación a la elección de carrera es por este
                            momento o situación en específico, o si existe una
                            tendencia a ser una persona indecisa en general.
                          </p>
                          <p>
                            La toma de decisiones es una habilidad que puede se
                            puede aprender, practicar y mejorar con el tiempo,
                            lo que puede ayudar a disminuir rasgos de indecisión
                            general.
                          </p>
                          <div className='scales-range' style={{ height: 300 }}>
                            <div className='range-single'>
                              <div className='label'>{grade.grade}</div>
                              <HorizontalRangeScale
                                scale='Indecisión General'
                                responses={grade.responses}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SlidePage>
                </Slide>
              );
            })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={sixthStep}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Toma de Decisiones</h1>
                <h2>Estilo de Decisión Predominante</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={sixthStep + 1}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Estilo de Decisión Predominante</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Estilo de Decisión Predominante</h1>
                    <p>
                      Las personas pueden afrontar las dificultades asociadas al
                      proceso de toma de decisión sobre su carrera a futuro de
                      distintas formas, siendo algunas formas más beneficiosas
                      para el proceso de elegir una carrera profesional.
                    </p>
                  </div>
                  <div className='image-wrapper'>
                    <img
                      style={{ height: 425, marginTop: 48 }}
                      src={EstiloDecisionModel}
                      alt='estilo-decision'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={sixthStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Estilo de Decisión Predominante</h2>
                </div>
                <div className='footnote'>
                  <div>
                    El estilo predominante de decisión es aquel en el que tiene{' '}
                    <strong>MAYOR</strong> puntaje.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Estilo de Decisión Predominante</h1>
                  <div className='scales-range' style={{ height: 650 }}>
                    <div className='range-row'>
                      <div className='label'>Afrontamiento Productivo</div>
                      <HorizontalRangeScale
                        scale='Afrontamiento Productivo'
                        responses={responses}
                        plainColor
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>Búsqueda de Apoyo</div>
                      <HorizontalRangeScale
                        scale='Búsqueda de Apoyo'
                        responses={responses}
                        plainColor
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>Afrontamiento No Productivo</div>
                      <HorizontalRangeScale
                        scale='Afrontamiento No-Producivo'
                        responses={responses}
                        plainColor
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData.gradeResponses.map((grade, index) => {
              return (
                <Slide
                  backgroundColor='#5a86e8'
                  key={`study${grade.grade}_${index}`}
                >
                  <SlidePage number={sixthStep + 3 + index}>
                    <SlideHeader campaign={campaign} />
                    <div className='third-left'>
                      <div>
                        <h1>Toma de Decisiones</h1>
                        <h2>Estilo de Decisión Predominante {grade.grade}</h2>
                      </div>
                      <div className='footnote'>
                        <div>
                          El estilo predominante de decisión es aquel en el que
                          tiene <strong>MAYOR</strong> puntaje.
                        </div>
                      </div>
                    </div>
                    <div className='slide-body big'>
                      <div className='slide-content'>
                        <h1>Estilo de Decisión Predominante {grade.grade}</h1>
                        <div className='scales-range' style={{ height: 650 }}>
                          <div className='range-row'>
                            <div className='label'>
                              Afrontamiento Productivo
                            </div>
                            <HorizontalRangeScale
                              scale='Afrontamiento Productivo'
                              responses={grade.responses}
                              plainColor
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>Búsqueda de Apoyo</div>
                            <HorizontalRangeScale
                              scale='Búsqueda de Apoyo'
                              responses={grade.responses}
                              plainColor
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Afrontamiento No Productivo
                            </div>
                            <HorizontalRangeScale
                              scale='Afrontamiento No-Producivo'
                              responses={grade.responses}
                              plainColor
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </SlidePage>
                </Slide>
              );
            })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={seventhStep}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Toma de Decisiones</h1>
                <h2>Dificultades de información</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={seventhStep + 1}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Dificultades de información</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Dificultades de información</h1>
                    <p>
                      Las dificultades de información se relacionan con el nivel
                      de conflicto (externo e interno) asociado a la toma de
                      decisión de carrera, así como a la calidad y cantidad de
                      información disponible sobre sí mismo (Self), las
                      ocupaciones o carreras, y el proceso de toma de decisión.
                    </p>
                  </div>
                  <div className='image-wrapper'>
                    <img
                      style={{ marginTop: 60 }}
                      src={DifInformacionModel}
                      alt='dificultad-informacion'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5a86e8'>
            <SlidePage number={seventhStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Toma de Decisiones</h1>
                  <h2>Dificultades de información</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en ROJO sugieren un alto nivel de conflicto o
                    falta de información. Resultados en VERDE sugieren un bajo
                    nivel de conflicto o falta de información.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Dificultades de información</h1>
                  <div className='scales-range' style={{ height: 650 }}>
                    <div className='range-row'>
                      <div className='label'>Conflictos externos</div>
                      <HorizontalRangeScale
                        scale='Conflictos externos'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>Conflictos internos</div>
                      <HorizontalRangeScale
                        scale='Conflictos internos'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>
                        Falta de información sobre ocupaciones
                      </div>
                      <HorizontalRangeScale
                        scale='Información sobre Ocupaciones'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>
                        Falta de información sobre Sí mismo
                      </div>
                      <HorizontalRangeScale
                        scale='Información sobre el Self'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>
                        Falta de información sobre el proceso
                      </div>
                      <HorizontalRangeScale
                        scale='Información sobre el proceso'
                        responses={responses}
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>Información inconsistente</div>
                      <HorizontalRangeScale
                        scale='Información inconsistente'
                        responses={responses}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData.gradeResponses.map((grade, index) => {
              return (
                <Slide
                  backgroundColor='#5a86e8'
                  key={`study${grade.grade}_${index}`}
                >
                  <SlidePage number={seventhStep + 3 + index}>
                    <SlideHeader campaign={campaign} />
                    <div className='third-left'>
                      <div>
                        <h1>Toma de Decisiones</h1>
                        <h2>Dificultades de información {grade.grade}</h2>
                      </div>
                      <div className='footnote'>
                        <div>
                          Resultados en ROJO sugieren un alto nivel de conflicto
                          o falta de información. Resultados en VERDE sugieren
                          un bajo nivel de conflicto o falta de información.
                        </div>
                      </div>
                    </div>
                    <div className='slide-body big'>
                      <div className='slide-content'>
                        <h1>Dificultades de información {grade.grade}</h1>
                        <div className='scales-range' style={{ height: 650 }}>
                          <div className='range-row'>
                            <div className='label'>Conflictos externos</div>
                            <HorizontalRangeScale
                              scale='Conflictos externos'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>Conflictos internos</div>
                            <HorizontalRangeScale
                              scale='Conflictos internos'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Falta de información sobre ocupaciones
                            </div>
                            <HorizontalRangeScale
                              scale='Información sobre Ocupaciones'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Falta de información sobre Sí mismo
                            </div>
                            <HorizontalRangeScale
                              scale='Información sobre el Self'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Falta de información sobre el proceso
                            </div>
                            <HorizontalRangeScale
                              scale='Información sobre el proceso'
                              responses={grade.responses}
                            />
                          </div>
                          <div className='range-row'>
                            <div className='label'>
                              Información inconsistente
                            </div>
                            <HorizontalRangeScale
                              scale='Información inconsistente'
                              responses={grade.responses}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </SlidePage>
                </Slide>
              );
            })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5a86e8'>
            <SlidePage isFullCover>
              <div className='title-page'>
                <div className='logo-big'>
                  <img
                    style={{ marginTop: 150 }}
                    src={VocationOneLogoWhite}
                    alt='vocation-one logo'
                  />
                </div>
              </div>
            </SlidePage>
          </Slide>
        </Deck>
      </Fragment>
    </ThemeProvider>
  );
};

export default VocationOneCollege;
